import { IconButton, IconLibrary } from "thrive-components";
import { getSourceListActionComponent } from "../ActionButtons";



const SourceListActions = ({content, isAlteringContentItem, isRefreshingFeed, onOpenListClick, addToSourceListClick, onRemoveSourceListClick}: {content: any, isAlteringContentItem :boolean, isRefreshingFeed: boolean, onOpenListClick:(listId: number, title: string)=>void, addToSourceListClick: (listId:number) => void, onRemoveSourceListClick:(listId: number)=>void}) => {
    const actionButtons = getSourceListActionComponent(content, isAlteringContentItem, isRefreshingFeed, addToSourceListClick, onRemoveSourceListClick);

    return (
        <span className="source-lists-actions">
            {actionButtons}

            <IconButton 
                key={`${content.id}-traverse-content`}
                ariaLabel={'Open list content'} 
                iconName={IconLibrary.CHEVRON_RIGHT} 
                className={`open-list-content-button`} 
                onButtonClick={() => onOpenListClick(content.id, content.title)} 
            />
        </span>
    );  
}

export default SourceListActions;